<script setup>
import { ref, onMounted } from 'vue';
import { $api } from '@/services';
import { useStore } from 'vuex';

const store = useStore();
const referralData = ref({});

const getReferralData = async () => {
	try {
		const response = await $api.org.getSpreadReferrals();
		referralData.value = response.data.data;
	} catch (error) {
		console.error(error);
	}
};

const copyCodeToClipboard = () => {
	navigator.clipboard.writeText(referralData.value.referral_code);
	store.dispatch('setAlertMessage', {
		message: 'Sao chép thành công',
	});
};

const formatPrice = (price) => {
	if (price == null || Number.isNaN(Number(price))) return '';
	return Number(price).toLocaleString('vi-VN');
};

onMounted(() => {
	getReferralData();
});
</script>
<template>
	<div>
		<div class="shadow-sm rounded-2xl p-4 bg-white mb-10">
			<div class="flex justify-between items-center mb-4">
				<div class="text-lg font-semibold">
					Giới thiệu trung tâm – Nhận thưởng lên đến 20%
				</div>
				<a
					href="https://www.luca.education/affiliate"
					target="_blank"
					class="text-yellow-700 text-sm font-semibold"
					>Tìm hiểu thêm</a
				>
			</div>
			<div class="p-4 bg-gray-50 rounded-lg mb-4">
				<div class="text-neutral-700 mb-2">Mã giới thiệu của bạn</div>
				<div class="mb-2">
					<div class="flex items-center gap-4">
						<div
							class="text-neutral-600 font-semibold text-2xl bg-white px-4 py-2 shadow-sm rounded-lg"
							style="min-width: 200px"
						>
							{{ referralData?.referral_code }}
						</div>
						<button
							class="button-p text-center whitespace-nowrap w-max"
							type="button"
							style="height: 46px"
							@click="copyCodeToClipboard"
						>
							Sao chép
						</button>
					</div>
				</div>
				<div class="flex items-center gap-2">
					<img
						src="@/assets/images/icons/info-circle-line.png"
						alt=""
					/>
					<div class="text-neutral-500">
						Trung tâm mới chỉ cần nhập mã này khi đăng ký để cả hai
						cùng nhận ưu đãi.
					</div>
				</div>
			</div>
			<div class="flex items-center gap-2">
				<img src="@/assets/images/icons/tick.png" alt="" />
				<div class="text-neutral-500">
					Mỗi lượt giới thiệu thành công nhận phiếu quà tặng bằng 20%
					giá trị gói dịch vụ trung tâm được bạn giới thiệu đã thanh
					toán
				</div>
			</div>
			<div class="flex items-center gap-2">
				<img src="@/assets/images/icons/tick.png" alt="" />
				<div class="text-neutral-500">
					Không giới hạn số lượt giới thiệu.
				</div>
			</div>
			<div class="flex items-center gap-2">
				<img src="@/assets/images/icons/tick.png" alt="" />
				<div class="text-neutral-500">
					Phiếu quà tặng được sử dụng một lần cho kỳ gia hạn tiếp theo
				</div>
			</div>
			<div class="flex items-center gap-2">
				<img src="@/assets/images/icons/tick.png" alt="" />
				<div class="text-neutral-500">
					Nếu giá trị phiếu lớn hơn phí gia hạn, phần còn lại sẽ được
					bảo lưu cho các kỳ tiếp theo.
				</div>
			</div>
		</div>
		<div class="bg-white p-4 rounded-lg shadow-sm mb-10">
			<div class="text-neutral-600 text-lg font-semibold mb-4">
				Thống kê
			</div>
			<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mb-4">
				<div
					class="p-4 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none"
				>
					<div class="text-neutral-500">Đã giới thiệu thành công</div>
					<div class="text-33 font-bold text-neutral-600 mt-2">
						{{ referralData?.successful_referrals || 0 }} trung tâm
					</div>
				</div>
				<div
					class="p-4 md:border-t border-b border-r md-down:border-l border-neutral-200 w-full"
				>
					<div class="text-neutral-500">Tổng giá trị đã nhận</div>
					<div class="text-33 font-bold text-neutral-600 mt-2">
						{{ formatPrice(referralData?.total_value_received || 0) }}đ
					</div>
				</div>
				<div
					class="p-4 md:border-t md:border-b md-down:border-l md-down:border-r border-neutral-200 w-full"
				>
					<div class="text-neutral-500">Đã sử dụng</div>
					<div class="text-33 font-bold text-neutral-600 mt-2">
						{{ formatPrice(referralData?.total_value_used || 0) }}đ
					</div>
				</div>
				<div
					class="p-4 border lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none"
				>
					<div class="text-neutral-500">Số dư</div>
					<div class="text-33 font-bold text-neutral-600 mt-2">
						{{ formatPrice(referralData?.balance || 0) }}đ
					</div>
				</div>
			</div>
			<div class="flex items-center gap-2">
				<img src="@/assets/images/icons/info-circle-line.png" alt="" />
				<div class="text-neutral-500">
					Số dư có thể được áp dụng cho kỳ gia hạn tiếp theo.
				</div>
			</div>
		</div>
		<div class="text-neutral-600 text-lg font-semibold mb-4">
			Danh sách giới thiệu
		</div>
		<div v-if="referralData?.referrals?.length > 0">
			<div class="shadow-sm sm:rounded-2xl overflow-hidden">
				<div class="__record__table overflow-x-auto scroll-bar">
					<div
						class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
					>
						<table class="min-w-full divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										scope="col"
										class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
									>
										STT
									</th>
									<th
										scope="col"
										class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
									>
										TRUNG TÂM
									</th>
									<th
										scope="col"
										class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
									>
										NGÀY ĐĂNG KÝ
									</th>
									<th
										scope="col"
										class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
									>
										PHIẾU QUÀ TẶNG
									</th>
									<th
										scope="col"
										class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
									>
										ĐÃ SỬ DỤNG
									</th>
									<th
										scope="col"
										class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
									>
										ĐÃ ÁP DỤNG VÀO
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(
										item, index
									) in referralData.referrals"
									:key="item.id || index"
									:class="
										index % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="text-neutral-700"
								>
									<td
										class="px-6 py-6 whitespace-nowrap text-neutral-700 w-16 text-center"
									>
										{{ index + 1 }}
									</td>
									<td
										class="px-6 py-6 whitespace-nowrap text-neutral-700"
									>
										{{ item?.refered_name || '-' }}
									</td>
									<td
										class="px-6 py-6 whitespace-nowrap text-neutral-700"
									>
										<div v-if="item?.inserted_at">
											{{
												$filters.formatDate2(
													item.inserted_at
												)
											}}
										</div>
										<div v-else>-</div>
									</td>
									<td
										class="px-6 py-6 whitespace-nowrap text-neutral-700"
									>
										{{ formatPrice(item?.discount || 0) }}đ
									</td>
									<td
										class="px-6 py-6 whitespace-nowrap text-neutral-700"
									>
										{{
											formatPrice(
												item?.used_at
													? item?.discount || 0
													: 0
											)
										}}đ
									</td>
									<td
										class="px-6 py-6 whitespace-nowrap text-neutral-700"
									>
										<div v-if="item?.used_at">
											{{
												$filters.formatDate2(
													item.used_at
												)
											}}
										</div>
										<div v-else>-</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div
			v-else
			class="w-full h-full mt-20 flex items-center justify-center flex-col"
		>
			<img
				src="@/assets/images/illustrations/not_found.png"
				alt=""
				height="250"
				width="250"
			/>
			<div
				class="text-neutral-500 text-lg text-center"
				style="max-width: 700px"
			>
				Chia sẻ mã giới thiệu để bắt đầu nhận phiếu quà tặng
			</div>
		</div>
	</div>
</template>